import { render, staticRenderFns } from "./Loading.vue?vue&type=template&id=1074a066&"
import script from "./Loading.vue?vue&type=script&lang=ts&"
export * from "./Loading.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VMain } from 'vuetify/lib/components/VMain';
import { VThemeProvider } from 'vuetify/lib/components/VThemeProvider';
installComponents(component, {VMain,VThemeProvider})
